module.exports = __webpack_public_path__ + "img/BG0.09dd4ee6.png";